import { render, staticRenderFns } from "./tableMultiple.vue?vue&type=template&id=6b6289b8&"
import script from "./tableMultiple.vue?vue&type=script&lang=js&"
export * from "./tableMultiple.vue?vue&type=script&lang=js&"
import style0 from "./tableMultiple.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports